"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _ModalFooter = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalFooter"));
var _Text3 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _reactIntl = require("react-intl");
var _Heading2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Heading"));
var _ButtonLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/ButtonLink"));
var _Box = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Box"));
var _usePublishPhoneVerificationVerificationFailedScreenDisplayed = _interopRequireDefault(require("../../consts/events/business/usePublishPhoneVerificationVerificationFailedScreenDisplayed"));
var _usePublishPhoneVerificationVerificationFailedContactSupportButtonClicked = _interopRequireDefault(require("../../consts/events/business/usePublishPhoneVerificationVerificationFailedContactSupportButtonClicked"));
var _usePublishPhoneVerificationVerificationFailedRetryButtonClicked = _interopRequireDefault(require("../../consts/events/business/usePublishPhoneVerificationVerificationFailedRetryButtonClicked"));
var _context = require("../../../../services/log/context");
var _events = require("../../consts/events");
var _jsxRuntime = require("react/jsx-runtime");
var _Heading, _Text, _Text2, _FormattedMessage, _FormattedMessage2;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const formatTime = seconds => {
  const hours = Math.ceil(seconds / 3600);
  return hours;
};
const PhoneVerificationFailed = _ref => {
  let {
    onChangeScreen,
    phoneVerificationRetryTime,
    phone
  } = _ref;
  const [remainingTime, setRemainingTime] = React.useState(phoneVerificationRetryTime !== null && phoneVerificationRetryTime !== void 0 ? phoneVerificationRetryTime : 2600);
  const {
    locale
  } = (0, _reactIntl.useIntl)();
  const publishScreenDisplayed = (0, _usePublishPhoneVerificationVerificationFailedScreenDisplayed.default)();
  const publishContactSupportButtonClicked = (0, _usePublishPhoneVerificationVerificationFailedContactSupportButtonClicked.default)();
  const publishRetryButtonClicked = (0, _usePublishPhoneVerificationVerificationFailedRetryButtonClicked.default)();
  const {
    log
  } = (0, _context.useLog)();
  (0, _react.useEffect)(() => {
    publishScreenDisplayed(phone.isVerified ? "verified" : "unverified");
    log(_events.PHONE_VERIFICATION_FAILED_SCREEN_DISPLAYED, {});
  }, [publishScreenDisplayed, phone.isVerified, log]);
  React.useEffect(() => {
    const timer = setInterval(() => {
      setRemainingTime(prev => {
        if (prev <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [phoneVerificationRetryTime]);
  const handleContinue = () => {
    publishRetryButtonClicked(phone.isVerified ? "verified" : "unverified");
    onChangeScreen("phoneVerification");
  };
  const handleContactSupport = () => {
    publishContactSupportButtonClicked(phone.isVerified ? "verified" : "unverified");
  };
  const intl = (0, _reactIntl.useIntl)();
  const lockedOutAltText = (0, _reactIntl.defineMessage)({
    id: "account.phone_verification.verification_failed.illustration_alt"
  });
  const imagesBaseUrl = "https://images.kiwi.com";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_ModalSection.default, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        margin: {
          bottom: "400"
        },
        display: "flex",
        justify: "center",
        tablet: {
          justify: "start"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          className: "hidden mm:block",
          title: intl.formatMessage(lockedOutAltText),
          alt: intl.formatMessage(lockedOutAltText),
          src: `${imagesBaseUrl}/account/login/locked-out.png`,
          width: 240,
          height: 125
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          className: "block mm:hidden",
          title: intl.formatMessage(lockedOutAltText),
          alt: intl.formatMessage(lockedOutAltText),
          src: `${imagesBaseUrl}/account/login/locked-out-mobile.png`,
          width: 160,
          height: 82
        })]
      }), _Heading || (_Heading = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Heading2.default, {
        type: "title1",
        spaceAfter: "normal",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.phone_verification.verification_failed.title"
        })
      })), _Text || (_Text = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text3.default, {
        type: "primary",
        spaceAfter: "large",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.phone_verification.verification_failed.description"
        })
      })), _Text2 || (_Text2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text3.default, {
        type: "primary",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.phone_verification.verification_failed.description_continued"
        })
      }))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalFooter.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
        direction: "row",
        justify: "end",
        spacing: "400",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
          href: `/${locale}/help/contact/`,
          type: "primary",
          onClick: handleContactSupport,
          children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.phone_verification.verification_failed.contact_support"
          }))
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          type: "primary",
          onClick: handleContinue,
          disabled: remainingTime > 0,
          children: remainingTime > 0 ?
          /*#__PURE__*/
          // TODO: replace this with FormattedRelativeTime and fixed copy after release (https://kiwicom.atlassian.net/browse/LOC-7724)
          // <>
          //   <FormattedMessage
          //     id="account.phone_verification.verification_failed.try_again_in_time"
          //     defaultMessage="Try again"
          //   />{" "}
          //   <FormattedRelativeTime value={formatTime(remainingTime)} unit="hour" />
          // </>
          (0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.phone_verification.verification_failed.try_again_in_time",
            values: {
              time: formatTime(remainingTime).toString()
            }
          }) : _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.phone_verification.verification_failed.try_again"
          }))
        })]
      })
    })]
  });
};
var _default = exports.default = PhoneVerificationFailed;